import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import "swiper/css";
import "swiper/css/navigation";
import { useDispatch, useSelector} from "react-redux";
import { setUpcomingEvents} from "../redux/slice/eventsSlice";

import {upcomingEventList} from "./EventsConstants";
import { CardType1 } from "../reusable/CardType1";

const UpcomingEvents = () => {
    const dispatch = useDispatch();
    const upcomingEvent = useSelector((state) => state.events.upcomingEvents);
  useEffect(() => {
     if(upcomingEventList.length > 0) {
      dispatch(setUpcomingEvents(upcomingEventList));
     }
  }, [dispatch]);
  
  const showNavigation = upcomingEvent?.length > 1;
//   const showNavigation = upcomingEvent?.length > 3;

  return (
    <section id="events" name="events">
      <div className="container has-text-centered mt-6">
        <h1 className="title main-title is-3">UPCOMING EVENTS</h1>
        <p class="subtitle has-text-grey cursive-text mt-3">Experience God’s Presence</p>
      </div>
      <div className="container is-fluid">
        <Swiper
          modules={[Navigation, Pagination]}
          navigation={showNavigation}
          allowTouchMove={showNavigation}
          slidesPerView={1}
          spaceBetween={20}
          breakpoints={{
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
        >
          {upcomingEvent.map((event, index) => (
            <SwiperSlide key={index}>
                <CardType1 events={event} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>

  );
};

export default UpcomingEvents;
